import axios from 'axios';
import { API_URL } from '../constants';

// @ts-ignore
const CSRF_TOKEN = document.querySelector('meta[name=csrf-token]').content;
const baseHeaders = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'X-CSRF-Token': CSRF_TOKEN,
};

if (process.env.RAILS_ENV === 'staging') {
  // @ts-ignore
  baseHeaders.Authorization = `Basic ${process.env.STAGING_AUTH_TOKEN}`;
}

const API = axios.create({
  baseURL: API_URL,
  timeout: 20000,
});

export default class BaseAPI {
  constructor() {
    API.interceptors.response.use(
      (response) => response,
      (error) => {
        if (
          error.response
          && (error.response.status === 401 || error.response.status === 403)
        ) {
          // TODO describe redirect logic
        }
        return Promise.reject(error);
      },
    );
  }

  authHeaders = (token: string) => {
    const headers = baseHeaders;
    // @ts-ignore
    return headers.append('Authorization', `Bearer ${token}`);
  };

  get(url: string, params: any, token: string | null = null) {
    return API({
      method: 'get',
      url,
      params,
      headers: token ? this.authHeaders(token) : baseHeaders,
    });
  }

  post(url: string, data: any, token: string | null = null) {
    return API({
      method: 'post',
      url,
      data,
      headers: token ? this.authHeaders(token) : baseHeaders,
    });
  }

  put(url: string, data: any, token: string | null = null) {
    return API({
      method: 'put',
      url,
      data,
      headers: token ? this.authHeaders(token) : baseHeaders,
    });
  }

  patch(url: string, data: any, token: string | null = null) {
    return API({
      method: 'patch',
      url,
      data,
      headers: token ? this.authHeaders(token) : baseHeaders,
    });
  }

  delete(url: string, params: any, token: string | null = null) {
    return API({
      method: 'delete',
      url,
      params,
      headers: token ? this.authHeaders(token) : baseHeaders,
    });
  }

  postFormData(url: string, data: FormData, token: string | null = null) {
    const formDataHeaders = {
      Accept: 'application/json',
      'X-CSRF-Token': CSRF_TOKEN,
    };
    
    if (process.env.RAILS_ENV === 'staging') {
      // @ts-ignore
      formDataHeaders.Authorization = `Basic ${process.env.STAGING_AUTH_TOKEN}`;
    }

    return API({
      method: 'post',
      url,
      data,
      headers: token ? { ...formDataHeaders, Authorization: `Bearer ${token}` } : formDataHeaders,
    });
  }
}
